import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Col, Row } from "reactstrap"
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts"
import { FeatureNameTicks, getFeatureDisplayName } from "../utils"

const FeatureUsageModal = ({ featureUsageReport }) => {
  const [chartData, setChartData] = useState([])

  useEffect(() => {
    if (featureUsageReport) {
      const data = []
      for (const [key, value] of Object.entries(featureUsageReport)) {
        if (value > 0) {
          data.push({
            feature: getFeatureDisplayName(key),
            views: value,
          })
        }
      }
      setChartData(data)
    }
  }, [featureUsageReport])

  return (
    <React.Fragment>
      <Row style={{ height: "500px" }}>
        <Col>
          <ResponsiveContainer>
            <BarChart
              data={chartData}
              layout="vertical"
              width={500}
              height={500}
              margin={{
                top: 20,
                right: 30,
                left: 100,
                bottom: 15,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis type="number" />
              <YAxis
                type="category"
                dataKey="feature"
                interval={0}
                tick={<FeatureNameTicks />}
              />
              <Tooltip cursor={{ fill: "rgb(220, 220, 220, 0.5)" }} />
              <Bar
                dataKey="views"
                name="Views"
                // stroke="#5e5c96"
                // strokeWidth={1.5}
                fill="#8884d8"
                barSize={20}
              />
            </BarChart>
          </ResponsiveContainer>
        </Col>
      </Row>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  featureUsageReport: state.Analytics.featureUsageReport,
})

export default connect(mapStateToProps)(FeatureUsageModal)
